import React from "react";
import { Link } from "gatsby"
import { slide as BurgerMenu } from "react-burger-menu";
import { getJpTitle, getPagesName, PAGE_IDS } from "src/utils/exportFunctions"
import logoImg from 'src/images/logo.svg'
import menuBtnImg from "src/images/menu_btn.svg"
import menuBtnCrsImg from "src/images/menu_btn_cross.svg"
import { getPrivacyPdf } from "src/utils/exportFunctions"

const Menu = (props) => {
    return (
        <div className="Menu">
            <BurgerMenu
                right
                disableAutoFocus
                width="50%"
                pageWrapId="page-wrap"
                outerContainerId="outer-container"
                customBurgerIcon={<img src={menuBtnImg} alt="開くボタン" />}
                customCrossIcon={<img src={menuBtnCrsImg} alt="閉じるボタン" />}
            >
                <ul className="bmList">
                    <li><Link to={'/' + getPagesName(PAGE_IDS['services'])}>{getJpTitle(PAGE_IDS['services'])}</Link></li>
                    <li><Link to={'/' + getPagesName(PAGE_IDS['company'])}>{getJpTitle(PAGE_IDS['company'])}</Link></li>
                    <li><Link to={'/' + getPagesName(PAGE_IDS['access'])}>{getJpTitle(PAGE_IDS['access'])}</Link></li>
                    <li><a href={getPrivacyPdf()} target="_blank" rel="noreferrer">{getJpTitle(PAGE_IDS['privacy'])}</a></li>
                </ul>
                <div className="bmFootLogo">
                    <Link to="/"><img src={logoImg} alt="ライオン企画株式会社" /></Link>
                </div>
                <small className="bmFootCopy">Copyright (c) LION KIKAKU CO., LTD. all rights reserved.</small>
            </BurgerMenu>
        </div>
    );
};

export default Menu;